import { z } from 'zod'

import { EnumBuilder, type ZodInfer } from '@mntn-dev/utility-types'

import { BidIdSchema } from '../unique-id.models.ts'
import { SurveyFeedbackSchema } from './common.ts'
import { SurveyTypeSchema } from './survey-types.ts'

export const [
  MakerBidRejectedByBrandReasons,
  MakerBidRejectedByBrandReasonSchema,
  MakerBidRejectedByBrandReasonEnum,
] = EnumBuilder(
  'lack-of-relevant-examples',
  'lack-of-expertise-in-required-skillset',
  'budget-too-high',
  'poor-past-experience-with-maker',
  'not-enough-information-in-pitch',
  'language-proficiency-or-location-not-ideal',
  'other'
)

export type MakerBidRejectedByBrandReason = ZodInfer<
  typeof MakerBidRejectedByBrandReasonSchema
>

export const MakerBidRejectedByBrandResponsesSchema = z.discriminatedUnion(
  'reason',
  [
    z.object({
      reason: MakerBidRejectedByBrandReasonSchema.extract(['other']),
      feedback: SurveyFeedbackSchema,
    }),
    z.object({
      reason: MakerBidRejectedByBrandReasonSchema.exclude(['other']),
      feedback: SurveyFeedbackSchema.optional(),
    }),
  ]
)

export type MakerBidRejectedByBrandResponses = ZodInfer<
  typeof MakerBidRejectedByBrandResponsesSchema
>

export const MakerBidRejectedByBrandSurveyDetailsSchema = z.object({
  surveyType: SurveyTypeSchema.extract(['maker-bid-rejected-by-brand']),
  bidId: BidIdSchema,
  responses: MakerBidRejectedByBrandResponsesSchema,
})
